import { CardElement, PlayStyle } from "../types/battle"

/** Стихия → против кого даёт RPS-бонус (синхронно с правилами / бэком) */
export const ELEMENT_BEATS: Record<CardElement, CardElement[]> = {
  FIRE: ["ICE", "LIGHTNING"],
  WIND: ["EARTH", "FIRE"],
  EARTH: ["WATER", "ICE"],
  WATER: ["FIRE", "LIGHTNING"],
  ICE: ["WIND", "WATER"],
  LIGHTNING: ["EARTH", "WIND"],
}

/** Стиль → кого побеждает (камень–ножницы–бумага) */
export const STYLE_BEATS: Record<PlayStyle, PlayStyle> = {
  ATTACK: "DEFENSE",
  DEFENSE: "SPEED",
  SPEED: "ATTACK",
}

export const ALL_PLAY_STYLES: PlayStyle[] = ["ATTACK", "DEFENSE", "SPEED"]

export const STYLE_NAMES: Record<PlayStyle, string> = {
  ATTACK: "Атака",
  DEFENSE: "Защита",
  SPEED: "Скорость",
}

export function elementBeats(attacker: CardElement, defender: CardElement): boolean {
  return ELEMENT_BEATS[attacker].includes(defender)
}

export function styleBeats(attacker: PlayStyle, defender: PlayStyle): boolean {
  return STYLE_BEATS[attacker] === defender
}
